// extracted by mini-css-extract-plugin
module.exports = {"kaart":"Geomap_kaart__3v5Z3","hidden":"Geomap_hidden__1p9ks"};